import { NextApiHandler, NextApiRequest, NextApiResponse } from 'next';
import getConfig from 'next/config';
import * as Sentry from '@sentry/node';
import { RewriteFrames } from '@sentry/integrations';

export function initSentry() {
  if (process.env.NEXT_PUBLIC_SENTRY_DSN && !Sentry.getCurrentHub().getClient()) {
    const config = getConfig();
    const distDir = `${config.serverRuntimeConfig.rootDir}/.next`;

    Sentry.init({
      enabled: process.env.NODE_ENV === 'production',
      integrations: [
        new RewriteFrames({
          iteratee: (frame) => {
            frame.filename = frame.filename.replace(distDir, 'app:///_next');
            return frame;
          }
        })
      ],
      dsn: process.env.NEXT_PUBLIC_SENTRY_DSN
    });
  }
}

export function withSentry(callback: NextApiHandler): NextApiHandler {
  initSentry();

  return async (req: NextApiRequest, res: NextApiResponse) => {
    try {
      return await callback(req, res);
    } catch (err) {
      Sentry.captureException(err);
      await Sentry.flush(2000);
      throw err;
    }
  };
}
